module.exports = __webpack_public_path__ + "img/3156482.48752183.jpg";